import {
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    createElementVNode as _$ce,
} from 'intact';
import {Bubble, Button} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Bubble, {
        'avatar': true,
        'roleName': '知识库助手',
        'variant': 'plain',
        'maxWidthString': '640px',
        '$blocks': function($blocks) {
            var _$blocks = {}, __$blocks = _$ex({}, $blocks);
            return (
                (
                    (_$blocks['content'] = function($super) {
                        return (
                            _$ce(2, 'div', [
                                _$ce(2, 'div', [
                                    _$ce(2, 'div', [
                                        _$ce(2, 'div', '检索到 3 条相关内容', 16, 'bubble-demo-panel-title'),
                                        _$ce(2, 'div', '来源：产品文档 / 设计规范 / FAQ', 16, 'bubble-demo-panel-subtitle')
                                    ], 4),
                                    _$ce(2, 'div', 'Top 3', 16, 'bubble-demo-panel-badge')
                                ], 4, 'bubble-demo-panel-head'),
                                _$ce(2, 'div', [
                                    _$ce(2, 'div', [
                                        _$ce(2, 'div', '1. Bubble 组件设计说明', 16, 'bubble-demo-panel-item-title'),
                                        _$ce(2, 'div', '包含 props、slots、variant 与 shape 的交互规范。', 16, 'bubble-demo-panel-item-desc')
                                    ], 4, 'bubble-demo-panel-item'),
                                    _$ce(2, 'div', [
                                        _$ce(2, 'div', '2. Markdown 渲染约定', 16, 'bubble-demo-panel-item-title'),
                                        _$ce(2, 'div', '说明聊天内容中的代码块、表格、链接和安全清洗策略。', 16, 'bubble-demo-panel-item-desc')
                                    ], 4, 'bubble-demo-panel-item'),
                                    _$ce(2, 'div', [
                                        _$ce(2, 'div', '3. 对话类组件的 footer 策略', 16, 'bubble-demo-panel-item-title'),
                                        _$ce(2, 'div', '由业务通过 footer 插槽按需接入操作区，避免组件内置过重语义。', 16, 'bubble-demo-panel-item-desc')
                                    ], 4, 'bubble-demo-panel-item')
                                ], 4, 'bubble-demo-panel-list'),
                                _$ce(2, 'div', [
                                    _$cc(Button, {
                                        'type': 'none',
                                        'children': '忽略'
                                    }),
                                    _$cc(Button, {
                                        'type': 'primary',
                                        'children': '插入到回答'
                                    })
                                ], 4, 'bubble-demo-panel-actions')
                            ], 4, 'bubble-demo-panel')
                        );
                    }),
                    (__$blocks['content'] = function($super, data) {
                        var block = $blocks['content'];
                        var callBlock = function() {
                            return _$blocks['content'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                (
                    (_$blocks['extra'] = function($super) {
                        return '可用于知识卡片、搜索结果、推荐模块等复杂区域';
                    }),
                    (__$blocks['extra'] = function($super, data) {
                        var block = $blocks['extra'];
                        var callBlock = function() {
                            return _$blocks['extra'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                __$blocks
            );
        }.call($this, _$em)
    });
};